export default __webpack_public_path__ + "static/homepage_footer_background-97a0973dc202828f25710640b63e58da.svg";